export const randomIntFromInterval = (min, max) => { // min and max included 
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export const isNumberAndGreaterThanZero  = (str) => {
  const numero = Number(str);
  return !isNaN(numero) && numero > 0;
};